export const SECTIONS = [
  { key: "articlePublications", label: "Article Publications", icon: "📄", color: "#4f8ef7", light: "#eaf1ff" },
  { key: "textBookPublications", label: "Text Book Publications", icon: "📚", color: "#7c3aed", light: "#f5f3ff" },
  { key: "patents", label: "Patents", icon: "💡", color: "#f7d34f", light: "#fffbe6" },
  { key: "copyrights", label: "Copy Rights", icon: "©️", color: "#06b6d4", light: "#ecfeff" },
  { key: "fellowships", label: "Fellowship", icon: "🏅", color: "#10b981", light: "#ecfdf5" },
  { key: "phd", label: "PhD", icon: "🎓", color: "#8b5cf6", light: "#f5f3ff" },
  { key: "swayamCourses", label: "Swayam / Courses", icon: "💻", color: "#3b82f6", light: "#eff6ff" },
  { key: "awards", label: "Awards", icon: "🏆", color: "#f7a84f", light: "#fff5e6" },
  { key: "innovativeTeaching", label: "Innovative Teaching", icon: "🧪", color: "#f74f6e", light: "#ffe6eb" },
  { key: "eContent", label: "E-Content", icon: "📱", color: "#0ea5e9", light: "#f0f9ff" },
  { key: "researchGrants", label: "Research Grants", icon: "💰", color: "#16a34a", light: "#f0fdf4" },
  { key: "guestLectures", label: "Guest Lectures", icon: "🎤", color: "#4fcf8e", light: "#e6fff3" },
  { key: "conferencePresentation", label: "Conference Presentation", icon: "🎯", color: "#e11d48", light: "#fff1f2" },
  { key: "shortResearchProjects", label: "Short Research Projects", icon: "🔬", color: "#d97706", light: "#fffbeb" },
];

export const SECTION_FIELDS = {
  articlePublications: [
    { key: "titleOfArticle", label: "Title of Article", type: "text", required: true },
    { key: "journalDetails", label: "Journal Details", type: "text" },
    { key: "authorNameAndPosition", label: "Author Name & Position", type: "text" },
    { key: "dciCategoryAndImpactFactor", label: "DCI Category & Impact Factor", type: "text" },
    { key: "acceptanceDetails", label: "Acceptance Details", type: "text" },
    { key: "monthAndYearOfPublication", label: "Month & Year of Publication", type: "text" },
    { key: "points", label: "Points", type: "number" },
    { key: "currentStatus", label: "Current Status", type: "dropdown", options: ["Sent", "Accepted", "Published"] },
    { key: "linkForArticle", label: "Link for Article", type: "text" },
  ],
  textBookPublications: [
    { key: "titleOfTextBook", label: "Title of Text Book", type: "text", required: true },
    { key: "publisherDetails", label: "Publisher Details", type: "text" },
    { key: "authorName", label: "Author Name", type: "text" },
    { key: "dciCategoryAndImpactFactor", label: "DCI Category & Impact Factor", type: "text" },
    { key: "acceptanceDetails", label: "Acceptance Details", type: "text" },
    { key: "monthAndYearOfPublication", label: "Month & Year of Publication", type: "text" },
    { key: "points", label: "Points", type: "number" },
    { key: "currentStatus", label: "Current Status", type: "dropdown", options: ["Sent", "Accepted", "Published"] },
    { key: "linkForTextBook", label: "Link for Text Book", type: "text" },
  ],
  patents: [
    { key: "titleOfPatent", label: "Title of Patent", type: "text", required: true },
    { key: "applicationSubmissionDetails", label: "Application Submission Details", type: "text" },
    { key: "authorName", label: "Author Name", type: "text" },
    { key: "acceptanceDetails", label: "Acceptance Details", type: "text" },
    { key: "monthAndYearOfPublication", label: "Month & Year of Publication", type: "text" },
    { key: "points", label: "Points", type: "number" },
    { key: "currentStatus", label: "Current Status", type: "dropdown", options: ["Sent", "Accepted", "Published"] },
    { key: "linkForPatent", label: "Link for Patent", type: "text" },
  ],
  copyrights: [
    { key: "title", label: "Title", type: "text", required: true },
    { key: "applicationSubmissionDetails", label: "Application Submission Details", type: "text" },
    { key: "authorName", label: "Author Name", type: "text" },
    { key: "acceptanceDetails", label: "Acceptance Details", type: "text" },
    { key: "monthAndYearOfPublication", label: "Month & Year of Publication", type: "text" },
    { key: "points", label: "Points", type: "number" },
    { key: "currentStatus", label: "Current Status", type: "dropdown", options: ["Sent", "Accepted", "Published"] },
    { key: "linkForCopyright", label: "Link for Copyright", type: "text" },
  ],
  fellowships: [
    { key: "title", label: "Title", type: "text", required: true },
    { key: "fellowshipRegistrationDetails", label: "Fellowship Registration Details", type: "text" },
    { key: "facultyName", label: "Faculty Name", type: "text" },
    { key: "monthAndYearOfInitiation", label: "Month & Year of Initiation", type: "text" },
    { key: "monthAndYearOfCompletion", label: "Month & Year of Completion", type: "text" },
    { key: "points", label: "Points", type: "number" },
    { key: "currentStatus", label: "Current Status", type: "dropdown", options: ["Initiated", "In Progress", "Completed"] },
    { key: "linkForFellowship", label: "Link for Fellowship", type: "text" },
  ],
  phd: [
    { key: "title", label: "Title", type: "text", required: true },
    { key: "phdRegistrationDetails", label: "PhD Registration Details", type: "text" },
    { key: "facultyName", label: "Faculty Name", type: "text" },
    { key: "monthAndYearOfInitiation", label: "Month & Year of Initiation", type: "text" },
    { key: "monthAndYearOfCompletion", label: "Month & Year of Completion", type: "text" },
    { key: "points", label: "Points", type: "number" },
    { key: "currentStatus", label: "Current Status", type: "dropdown", options: ["Initiated", "In Progress", "Completed"] },
    { key: "linkForPhD", label: "Link for PhD", type: "text" },
  ],
  swayamCourses: [
    { key: "title", label: "Title", type: "text", required: true },
    { key: "swayamRegistrationDetails", label: "Swayam Registration Details", type: "text" },
    { key: "facultyName", label: "Faculty Name", type: "text" },
    { key: "monthAndYearOfInitiation", label: "Month & Year of Initiation", type: "text" },
    { key: "monthAndYearOfCompletion", label: "Month & Year of Completion", type: "text" },
    { key: "points", label: "Points", type: "number" },
    { key: "currentStatus", label: "Current Status", type: "dropdown", options: ["Initiated", "In Progress", "Completed"] },
    { key: "linkForCourse", label: "Link for Course", type: "text" },
  ],
  awards: [
    { key: "awardName", label: "Award Name", type: "text", required: true },
    { key: "awardGivenBy", label: "Award Given By", type: "text" },
    { key: "facultyName", label: "Faculty Name", type: "text" },
    { key: "monthAndDate", label: "Month & Date", type: "text" },
    { key: "currentStatus", label: "Current Status", type: "dropdown", options: ["Received", "Nominated", "Pending"] },
    { key: "linkForAward", label: "Link for Award", type: "text" },
  ],
  innovativeTeaching: [
    { key: "facultyName", label: "Faculty Name", type: "text", required: true },
    { key: "monthAndDate", label: "Month & Date", type: "text" },
    { key: "topic", label: "Topic", type: "text" },
    { key: "innovationDetails", label: "Innovation Details", type: "textarea" },
    { key: "sessionType", label: "Session Type", type: "dropdown", options: ["Theory", "Practical"] },
    { key: "linkForSession", label: "Link for Session", type: "text" },
  ],
  eContent: [
    { key: "facultyName", label: "Faculty Name", type: "text", required: true },
    { key: "monthAndDate", label: "Month & Date", type: "text" },
    { key: "topic", label: "Topic", type: "text" },
    { key: "eContentDetails", label: "E-Content Details", type: "textarea" },
    { key: "sessionType", label: "Session Type", type: "dropdown", options: ["Theory", "Practical"] },
    { key: "linkForContent", label: "Link for Content", type: "text" },
  ],
  researchGrants: [
    { key: "facultyName", label: "Faculty Name", type: "text", required: true },
    { key: "monthAndDate", label: "Month & Date", type: "text" },
    { key: "topic", label: "Topic", type: "text" },
    { key: "grantDetails", label: "Grant Details", type: "textarea" },
    { key: "fundingAgencyDetails", label: "Funding Agency Details", type: "text" },
    { key: "linkForGrant", label: "Link for Grant", type: "text" },
  ],
  guestLectures: [
    { key: "facultyName", label: "Faculty Name", type: "text", required: true },
    { key: "monthAndDate", label: "Month & Date", type: "text" },
    { key: "topic", label: "Topic", type: "text" },
    { key: "guestLectureDetails", label: "Guest Lecture Details", type: "textarea" },
    { key: "organizedBy", label: "Organized By", type: "text" },
    { key: "linkDetails", label: "Link Details", type: "text" },
  ],
  conferencePresentation: [
    { key: "facultyName", label: "Faculty Name", type: "text", required: true },
    { key: "monthAndDate", label: "Month & Date", type: "text" },
    { key: "topic", label: "Topic", type: "text" },
    { key: "presentationDetails", label: "Presentation Details", type: "textarea" },
    { key: "organizedBy", label: "Organized By", type: "text" },
    { key: "link", label: "Link", type: "text" },
  ],
  shortResearchProjects: [
    { key: "facultyName", label: "Faculty Name", type: "text", required: true },
    { key: "monthAndDate", label: "Month & Date", type: "text" },
    { key: "topic", label: "Topic", type: "text" },
    { key: "proposalDetails", label: "Proposal Details", type: "textarea" },
    { key: "investigatorDetails", label: "Investigator Details", type: "text" },
    { key: "linkDetails", label: "Link Details", type: "text" },
  ],
};
